import Chart from 'chart.js/auto';
import {Compass1ChartJS} from "./Compass1";

export class Compass2ChartJS extends Compass1ChartJS {

  constructor(target) {
    super(target, "data/algorithms/Compass2-HumidDay.csv", 2);
  }

}
